document.addEventListener("DOMContentLoaded", function() {
  const checkbox = document.querySelector(".theme-toggle");
  const prefersDarkScheme = window.matchMedia("(prefers-color-scheme: dark)");

  let currentTheme = localStorage.getItem("theme");
  if (currentTheme == "dark") {
    document.body.classList.toggle("dark-theme");
    checkbox.checked = true;
  } else if (currentTheme == "light") {
    document.body.classList.toggle("light-theme");
    checkbox.checked = false;
  } else if (prefersDarkScheme.matches) {
    document.body.classList.toggle("dark-theme");
    checkbox.checked = true;
    currentTheme = "dark";
  } else {
    document.body.classList.toggle("light-theme");
    checkbox.checked = false;
    currentTheme = "light";
  }

  localStorage.setItem("theme", currentTheme);

  checkbox.addEventListener("change", function () {
    let theme;
    if (this.checked) {
      document.body.classList.toggle("dark-theme");
      document.body.classList.toggle("light-theme");
      theme = "dark";
    } else {
      document.body.classList.toggle("light-theme");
      document.body.classList.toggle("dark-theme");
      theme = "light";
    }
    localStorage.setItem("theme", theme);
  });
});